// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__qWfSd","footer":"ModalUpdate_footer__22w2Y"};